<template>
    <div class="section mt-4">
        <div class="row">
            <div class="col-lg-2">
            </div>
            <div class="col-lg-8">
                <div class="card shadow p-3 " style="background-color: #dbefff;">
                    <div class="row">
                        <div class="col-2 d-flex">
                            <img :src="image" class="rounded float-left" style="width: 100%;" alt="">
                        </div>
                        <div class="col-10 my-auto">
                            {{ message }}
                        </div>           
                    </div>
                </div>
            </div>
            <div class="col-lg-2">
            </div>
        </div>     
    </div>
</template>

<script>
export default {
    data() {
        return {
            images: ['winner_ch.svg'],
            image: '',
        }
    },
    props: ['message', 'type'],
    mounted() {
        if (this.type == '0') {
            this.image = '/icons/' + this.images[0]
        }
    },
}
</script>